import { AlertTriangle, BadgeDollarSign, CalendarClock, WalletCards } from "lucide-react";
import { UserKpiCard } from "@/pages/users/components/UserKpiCard";
import type { CreanceMetrics } from "../creance-calculations";
import { formatMoney } from "../creance-formatters";

interface CreanceStatsGridProps {
  rowsCount: number;
  metrics: CreanceMetrics;
}

export function CreanceStatsGrid({ rowsCount, metrics }: CreanceStatsGridProps) {
  return (
    <div className="mb-6 grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
      <UserKpiCard
        label="Échéances dues"
        value={String(rowsCount)}
        detail={`${metrics.overdueCount} en retard`}
        icon={CalendarClock}
        tone={metrics.overdueCount > 0 ? "danger" : "gold"}
      />
      <UserKpiCard
        label="Principal dû"
        value={formatMoney(metrics.totalPrincipal)}
        detail={`${formatMoney(metrics.totalExpected)} attendu`}
        icon={WalletCards}
        tone="gold"
      />
      <UserKpiCard
        label="Pénalités dues"
        value={formatMoney(metrics.totalPenalty)}
        detail="Solde de pénalités"
        icon={AlertTriangle}
        tone={metrics.totalPenalty > 0 ? "danger" : "neutral"}
      />
      <UserKpiCard
        label="Déjà payé"
        value={formatMoney(metrics.totalPaid)}
        detail="Principal + pénalités"
        icon={BadgeDollarSign}
        tone="success"
      />
    </div>
  );
}
